import React from "react";
import "../styles/home.css";

export default function Home() {
  return (
    <div className="home-container">

      {/* 1. HERO SECTION WITH PARALLAX EFFECT */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-logo-box">
            <span className="logo-emoji">🌾</span>
          </div>
          <h1>बेलपिंपळगाव</h1>
          <p className="hero-tagline">परंपरा • संस्कृती • प्रगती</p>
          <div className="status-badge">
            <span className="badge-icon">🏆</span>
            <span className="badge-text">आदर्श ग्रामपंचायत, महाराष्ट्र</span>
          </div>
          <button className="cta-button">गावाबद्दल अधिक जाणून घ्या</button>
        </div>
      </section>

      {/* 2. INTRO SECTION - MODERN CLEAN LAYOUT */}
      <section className="intro">
        <div className="intro-card">
          <div className="intro-graphic">🌱</div>
          <div className="intro-text">
            <h2>आमचं गाव – आमचा अभिमान</h2>
            <div className="section-divider"></div>
            <p>
              बेलपिंपळगाव हे शांत, प्रगतशील व एकसंध गाव असून
              शेती, शिक्षण, संस्कृती व सामाजिक ऐक्य यासाठी ओळखले जाते.
              ग्रामपंचायतीमार्फत गावाच्या सर्वांगीण विकासासाठी सातत्याने
              प्रयत्न सुरू आहेत.
            </p>
          </div>
        </div>
      </section>

      {/* 3. STATS SECTION - GLASSMORPHISM CARDS */}
      <section className="stats">
        <div className="stats-header">
          <h2>गावाची एका दृष्टिक्षेपात प्रगती</h2>
        </div>
        <div className="stats-grid">
          <div className="stat-card unique-card-1">
            <div className="stat-icon">🏠</div>
            <h3>1200+</h3>
            <p>घरे</p>
          </div>
          <div className="stat-card unique-card-2">
            <div className="stat-icon">👥</div>
            <h3>5000+</h3>
            <p>लोकसंख्या</p>
          </div>
          <div className="stat-card unique-card-3">
            <div className="stat-icon">💧</div>
            <h3>24x7</h3>
            <p>पाणीपुरवठा</p>
          </div>
          <div className="stat-card unique-card-4">
            <div className="stat-icon">✨</div>
            <h3>100%</h3>
            <p>स्वच्छता</p>
          </div>
        </div>
      </section>

      {/* 4. MESSAGE SECTION - MODERN GRADIENT & FOCUS */}
      <section className="message-container">
        <div className="message-overlay">
          <h2>ग्रामपंचायतीचा संदेश</h2>
          <div className="message-quote-box">
            <span className="quote-icon-left">“</span>
            <p>
              ग्रामविकास हा केवळ प्रशासनाचा विषय नसून
              प्रत्येक नागरिकाच्या सक्रिय सहभागातूनच
              आदर्श गाव घडते.
            </p>
            <span className="quote-icon-right">”</span>
          </div>
          <strong className="signature">— ग्रामपंचायत बेलपिंपळगाव</strong>
        </div>
      </section>

      {/* 5. CULTURE SECTION - COLORFUL MODERN GRID */}
      <section className="culture">
        <h2>সংस्कृती व सण-उत्सव</h2>
        <p className="culture-sub">
          बेलपिंपळगाव मधील प्रमुख धार्मिक व सामाजिक उत्सव
        </p>

        <div className="festival-grid">
          {[
            {icon: "🚩", name: "छत्रपती शिवाजी महाराज जयंती"},
            {icon: "🔵", name: "डॉ. बाबासाहेब आंबेडकर जयंती"},
            {icon: "🟢", name: "आण्णाभाऊ साठे जयंती"},
            {icon: "🛕", name: "स्वामी समर्थ मंदिर उत्सव"},
            {icon: "🔥", name: "हनुमान जयंती"},
            {icon: "🪔", name: "राम नवमी"},
            {icon: "🌸", name: "नवरात्र उत्सव"},
            {icon: "☪️", name: "ईद – रमजान / बकरी ईद"}
          ].map((item, index) => (
            <div key={index} className="festival-card-wrapper">
              <div className="festival-card">
                <span className="fest-icon">{item.icon}</span>
                <span className="fest-name">{item.name}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* 6. MAP SECTION - MODERN EMBED */}
      <section className="map-container">
        <h2>गावाचा नकाशा</h2>
        <div className="map-wrapper">
          <iframe
            title="Belpimpalgaon Map"
            src="https://www.google.com/maps?q=Belpimpalgaon&output=embed"
            loading="lazy"
          />
          <div className="map-pin">📍</div>
        </div>
      </section>

    </div>
  );
}